import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, take } from 'rxjs/operators';

@Component({
    selector: 'ph-auth-flow-sdk-callback-component',
    template: '',
    providers: [],
    standalone: false
})
export class SdkCallbackComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    // Wait for Auth0 to process the callback and authenticate
    this.authService.isAuthenticated$
      .pipe(
        filter(isAuthenticated => isAuthenticated),
        take(1)
      )
      .subscribe(() => {
        // Navigate to the intended destination or home
        this.router.navigate(['/']);
      });
  }
}
